<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Reply</p>
            </header>
            <section class="modal-card-body">
              <article v-if="notes" class="media note">
                <figure class="media-left">
                  <p class="image is-32x32">
                    <img :src="userAvatarById(notes.actor_id)" class="note-avatar" alt="">
                  </p>
                </figure>
                <div class="media-content">
                  <div class="content">
                    <strong>{{ actorNameByNote(notes) }}</strong>
                    <small>{{ $filters.note_date(notes.created_at) }}</small>
                    <div>
                    <span v-if="notes.subject">
                        <strong>Subject: </strong>{{ notes.subject }}&nbsp;
                    </span>
                    </div>
                    <div class="break-word" v-html="notes.message"></div>
                  </div>
                </div>
              </article>
                <o-field label="Message">
                      <quill-editor :content="message" @update:content="message = $event" :content-type="'text'"  :error="getError('message')" />
                </o-field>
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button :disabled="!message.length > 1"
                        @update:disabled="message.length"
                        @click.prevent="handleCreateNote"
                        class="button is-primary"
                        v-submit="submitting"
                >Reply</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import HandlesForm from './../../mixins/HandlesForm'
    import { mapActions, mapGetters } from 'vuex'
    import {QuillEditor} from "@vueup/vue-quill";

    export default {
      components: {QuillEditor},
        mixins: [HandlesForm],

        props: ['referenceId', 'referenceType'],

        data () {
            return {
                submitting: false,
                text: '',
                message: ''
            }
        },

        methods: {
            ...mapActions(['createNote', 'fetchNotesById']),

            handleCreateNote () {
                let submit = this.wrapSubmit(this.createNote)

                submit({
                    message: this.message,
                    reference_id: this.referenceId,
                    reference_type: this.referenceType,
                    files: [],
                    subject: "Reply to " + this.referenceType + " #" + this.referenceId,
                }).then(res => {
                    this.successMessage('Reply has been sent')
                    this.$parent.$parent.$emit('update:active', false)
                    this.message = ''
                    $(".ql-editor > p").empty()

                    if (this.referenceType == 'task') {
                        this.$store.dispatch('processTask', {
                            id: this.referenceId,
                            last_editor_id: this.currentUserId
                        })
                    }

                    return res
                })
            }
        },

        computed: {
            ...mapGetters([
                'latestNoteMessageByProjectId',
                'latestNoteMessageByTaskId',
                'latestNoteByTaskId',
                'latestNoteByProjectId',
                'actorNameByNote',
                'userAvatarById',
                'currentUserId'
            ]),

            latestNoteMessage () {
                return this.referenceType === 'project'
                    ? this.latestNoteMessageByProjectId(this.referenceId)
                    : this.latestNoteMessageByTaskId(this.referenceId)
            },

            notes () {
                return this.referenceType  === 'project'
                    ? this.latestNoteByProjectId(this.referenceId)
                    : this.latestNoteByTaskId(this.referenceId)
            }

        },
      mounted() {
        this.fetchNotesById(this.referenceId)
            .catch(err => {
              console.log(err)
            })
      }
    }
</script>
